import { config } from '../utils.js';

const { 
    brand_filter, 
    category_filter, 
    color_filter, 
    max_price_filter, 
    min_price_filter, 
    size_filter, 
    status_filter,
    fair_price,
    sort,
    query
} = config.currentSearchFilters || {};

export const userAppliedFilters = {
    brand_filter: brand_filter || [],
    category_filter: category_filter || [],
    color_filter: color_filter || [],
    max_price_filter: max_price_filter,
    min_price_filter: min_price_filter,
    size_filter: size_filter || [],
    status_filter: status_filter || [],
    fair_price: fair_price,
    sort_filter: sort,
    query
}